module.exports = __webpack_public_path__ + "static/img/server4.95bcc4f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/server4.jpeg
// module id = Cwvp
// module chunks = 1